<template>
  <div class="insight-desativar-dialog">
    <el-dialog
      v-model="isOpen"
      :show-close="false"
      width="400px"
      class="insight-desativar-drawer"
      :before-close="handleClose"
    >
      <template #header>
        <HeaderIaIcone title="Desativar Agente de IA? " @close="handleClose" />
      </template>

      <div class="insight-desativar-drawer__content">
        <p>
          Ao confirmar a desativação, novos relatórios de insights
          <b>deixarão de ser gerados </b> .
        </p>

        <p>
          O histórico das análises permanecerá disponível para consulta na
          plataforma.
        </p>
      </div>

      <template #footer>
        <div class="insight-config-drawer__footer">
          <PButton type="neutral" @click="handleDesativar">
            Confirmar desativação
          </PButton>
          <div>
            <!-- <F360Button @click="handleClose" type="outline">Voltar</F360Button> -->
            <F360Button filled @click="handleAtivar">Manter ativo</F360Button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup lang="ts">
import F360Button from "@/ui/components/Buttons/Button/F360Button.vue";
import HeaderIaIcone from "../../../../components/HeaderIaIcone.vue";
import { PButton } from "@f360-dev/f360-prisma";
import type { InsightConfiguracaoGateway } from "../../services/InsightConfiguracaoGateway";

const emits = defineEmits<{
  (e: "ativar"): void;
  (e: "desativar"): void;
}>();

const isOpen = defineModel<boolean>({ default: true });

defineProps<{
  gateway: InsightConfiguracaoGateway;
}>();

const handleClose = () => {
  isOpen.value = false;
};

const handleDesativar = async () => {
  emits("desativar");
  handleClose();
};

const handleAtivar = () => {
  emits("ativar");
  handleClose();
};
</script>

<style lang="scss">
.insight-desativar-dialog {
  .financas-dialog {
    padding: 0;
  }

  .financas-dialog__header {
    padding-bottom: 0;
  }

  .insight-desativar-drawer {
    &__content {
      display: flex;
      flex-direction: column;
      text-align: center;
    }
  }
}
</style>
